type BIAnalyticsGuarded = {
  isInitialized(): boolean;
  isTrackingEnabled(): boolean;
};

type GuardedMethod = (...args: unknown[]) => unknown;

function wrapWhen(
  guard: (service: BIAnalyticsGuarded) => boolean,
  descriptor: PropertyDescriptor,
) {
  const originalMethod = descriptor.value as GuardedMethod | undefined;

  descriptor.value = function (
    this: BIAnalyticsGuarded,
    ...args: unknown[]
  ): unknown {
    if (!guard(this)) {
      return;
    }

    return originalMethod?.apply(this, args);
  };

  return descriptor;
}

export function requiresInitialized(
  _target: object,
  _propertyKey: string | symbol,
  descriptor: PropertyDescriptor,
) {
  return wrapWhen((service) => service.isInitialized(), descriptor);
}

export function requiresTracking(
  _target: object,
  _propertyKey: string | symbol,
  descriptor: PropertyDescriptor,
) {
  return wrapWhen(
    (service) => service.isInitialized() && service.isTrackingEnabled(),
    descriptor,
  );
}
